// 配置路由相关信息
import VueRouter from 'vue-router'
import Vue from 'vue'
import store from '../store/index'
// import storage from '../utils/storage'
// import { encryptstringadd } from '../api/api'

const Login = () => import('../views/Login.vue')
const Home = () => import('../views/Home.vue')
const ProductAggregationPage = () => import('../views/product-aggregation-page.vue')
const HomeVisitors = () => import('../views/HomeVisitors.vue')
const HomeDetail = () => import('../views/HomeDetail.vue')
const Register = () => import('../views/Register.vue')

// 安装插件
Vue.use(VueRouter)

// 创建VueRouter对象
const routes = [
    {
        path: '/',
        name: 'home',
        redirect: '/home',
    },
    {
        path: '/product-aggregation-page',
        name: 'product-aggregation-page',
        component: ProductAggregationPage,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/homeDetail',
        name: 'homeDetail',
        component: HomeDetail,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/HomeVisitors',
        name: 'HomeVisitors',
        component: HomeVisitors,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            // 是否为游客
            isVisitors: true,
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            showNav: true
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            showNav: true
        }
    },
    {
        path: '/commondityIndex',
        name: 'commondityIndex',
        redirect: '/commondityIndex/cManageIndex',
        component: () => import('../views/commondityManage/CommondityIndex.vue'),
        children: [
            {
                path: 'cManageLeavel',
                name: 'cManageLeavel',
                component: () => import('../views/commondityManage/shopLeavel.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'cManageEdit',
                name: 'cManageEdit',
                redirect: '/commondityIndex/cManageEdit/cBaseinfo',
                component: () => import('../views/commondityManage/editCommondity/CommondityEditIndex.vue'),
                children: [
                    {
                        path: 'cBaseinfo',
                        name: 'cBaseinfo',
                        component: () => import('../views/commondityManage/editCommondity/baseInfo.vue'),
                        meta: {
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cMultiPrice',
                        name: 'cMultiPrice',
                        component: () => import('../views/commondityManage/editCommondity/multiPrice.vue'),
                        meta: {
                            requireAuth: true,
                        }
                    },
                ]
            },
        ],
    },
    {
        path: '/comSalesIndex',
        name: 'comSalesIndex',
        component: () => import('../views/commercialSalesManage/ComSalesIndex.vue'),
        redirect: '/comSalesIndex/cShopList',
        children: [
            {
                path: 'cRetailOrderList',
                name: 'cRetailOrderList',
                component: () => import('../views/commercialSalesManage/order/retailList.vue'),
                meta: {
                    requireAuth: true
                }
            },

            {
                path: 'cRetailAddOrder',
                name: 'cRetailAddOrder',
                component: () => import('../views/commercialSalesManage/order/retailAddOrder.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'cRetailOrderDetail',
                name: 'cRetailOrderDetail',
                component: () => import('../views/commercialSalesManage/order/retailDetail.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'cPaymentPayList',
                name: 'cPaymentPayList',
                component: () => import('../views/commercialSalesManage/payment/payList.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'cPaymentPayDetail',
                name: 'cPaymentPayDetail',
                component: () => import('../views/commercialSalesManage/payment/payDetail.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'cPaymentReceiveGoods',
                name: 'cPaymentReceiveGoods',
                component: () => import('../views/commercialSalesManage/payment/receiveGoods.vue'),
                meta: {
                    requireAuth: true,
                }
            },
        ],
    },
    {
        path: '/comSelectMsgIndex',
        name: 'comSelectMsgIndex',
        component: () => import('../views/commoditySelectMsgManage/ComSelectMsgIndex.vue'),
        redirect: '/comSelectMsgIndex/cSelectMsgList',
        children: [
            {
                path: 'cSelectMsgList',
                name: 'cSelectMsgList',
                component: () => import('../views/commoditySelectMsgManage/list.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'cSelectMsgEdit',
                name: 'cSelectMsgEdit',
                component: () => import('../views/commoditySelectMsgManage/edit.vue'),
                meta: {
                    requireAuth: true
                }
            },
        ]
    },

    // 管理中心
    {
        path: '/manageCenterIndex',
        name: 'manageCenterIndex',
        component: () => import('../views/managementCenter/ManageCenterIndex.vue'),
        redirect: '/manageCenterIndex/receivingInfo',
        children: [
            {
                path: 'receivingInfo',
                name: 'receivingInfo',
                component: () => import('../views/managementCenter/receivingInfo.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'warehouseInfo',
                name: 'warehouseInfo',
                component: () => import('../views/managementCenter/warehouseInfo.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'orderList',
                name: 'orderList',
                component: () => import('../views/managementCenter/orderList.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'selectMsgList',
                name: 'selectMsgList',
                component: () => import('../views/managementCenter/selectMsgList.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'userManagement',
                name: 'userManagement',
                component: () => import('../views/managementCenter/userManagement.vue'),
                meta: {
                    requireAuth: true
                }
            },
        ]
    },

    // 企业管理
    {
        path: '/companyIndex',
        name: 'companyIndex',
        component: () => import('../views/companyManage/CompanyIndex.vue'),
        // redirect: '/companyIndex/companyDetail/:qyid',
        children: [
            {
                path: 'companyDetail',
                name: 'companyDetail',
                component: () => import('../views/companyManage/companyDetail.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'userDetail',
                name: 'userDetail',
                component: () => import('../views/companyManage/userDetail.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'userList',
                name: 'userList',
                component: () => import('../views/companyManage/userList.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'companyList',
                name: 'companyList',
                component: () => import('../views/companyManage/companyList.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'companyUserDetail',
                name: 'companyUserDetail',
                component: () => import('../views/companyManage/companyUserDetail.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'companyUserList',
                name: 'companyUserList',
                component: () => import('../views/companyManage/companyUserList.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'addRuleHPf',
                name: 'addRuleHPf',
                component: () => import('../views/companyManage/addRuleHPf.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'consumptionRule',
                name: 'consumptionRule',
                component: () => import('../views/companyManage/consumptionRule.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'serviceNitoceManage',
                name: 'serviceNitoceManage',
                component: () => import('../views/companyManage/serviceNitoceManage.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'distributionWithdrawalFee',
                name: 'distributionWithdrawalFee',
                component: () => import('../views/companyManage/distributionWithdrawalFee.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'settlementManagement',
                name: 'settlementManagement',
                component: () => import('../views/companyManage/settlementManagement.vue'),
                meta: {
                    requireAuth: true,
                }
            },
        ],
        meta: {
            requireAuth: true,
        }
    },
]

// 
const router = new VueRouter({
    // mode: 'history',
    routes,
    scrollBehavior() {
        // to, from, savedPosition
        return { x: 0, y: 0 }
    }
})

let isFetchingUserInfo = false; // 用于防止重复请求

router.beforeEach(async (to, _from, next) => {

    const { TOKEN, USERINFO } = store.state;

    // 如果是初次进入页面，允许访问 HomeVisitors 页面
    if (_from.name === 'login' && to.name === 'HomeVisitors') {
        return next();
    }

    // 如果当前路由是 HomeVisitors，则重定向到 login 页面
    if (to.name === 'HomeVisitors') {
        return next({ path: '/login' });
    }
    
    // 如果当前路径不需要认证，直接放行
    if (to.meta && !to.meta.requireAuth) {
        // 如果用户已登录，重定向到首页或其他需要认证的页面
        if (TOKEN) {
            return next({ path: '/home' }); // 或者其他需要认证的页面
        }
        return next();
    }

    // 检查 TOKEN 是否存在
    if (!TOKEN) {
        // 如果 TOKEN 不存在，重定向到登录页面
        return next({ path: '/login' });
    } else {
        // TOKEN 存在，获取用户信息
        if (!isFetchingUserInfo) {
            isFetchingUserInfo = true;
            await store.dispatch('fetchGetUserInfo', { token: TOKEN, router: router });
            isFetchingUserInfo = false;
        }
        // 如果当前登陆账户是游客（limittype=3），并且是刷新页面，则重定向到登录页面
        if (USERINFO && USERINFO.limittype == 3 && _from.path !== '/login') {
            return next({ path: '/login' });
        } else {
            // 用户已登录，允许访问需要认证的页面
            return next();
        }
    }


});

// 将router对象传入到Vue实例中
export default router